module.exports = __webpack_public_path__ + "img/cibcinsurance-logo-lg-en.e3948d4c.png";